/**
 * Admin → Device secrets (container): pick a studio; its config's devices with
 * "set"/"not set" and when (never a value), set or replace one, delete one.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { useDeleteDeviceSecret, useDeviceSecrets, useMaybeStudio, useSetDeviceSecret, useStudios } from '../../app/hooks.js';
import { DeviceSecretsPanel } from '../../components/admin/DeviceSecretsPanel.js';
import { deviceIdsOf } from '../../lib/admin/view.js';
import { errorText } from './common.js';

export function DeviceSecretsView() {
  const studios = useStudios();
  const [picked, setPicked] = useState<string | null>(null);
  const studioId = picked ?? studios.data?.[0]?.studioId ?? null;
  const studio = useMaybeStudio(studioId);
  const secrets = useDeviceSecrets(studioId);
  const set = useSetDeviceSecret();
  const remove = useDeleteDeviceSecret();
  const deviceIds = studioId !== null && studio.data?.studioId === studioId ? deviceIdsOf(studio.data.config) : [];
  return (
    <DeviceSecretsPanel
      studios={(studios.data ?? []).map((s) => ({ id: s.studioId, name: s.name }))}
      studioId={studioId}
      deviceIds={deviceIds}
      secrets={secrets.data ?? []}
      loading={secrets.isFetching && secrets.data === undefined}
      pending={set.isPending || remove.isPending}
      error={errorText(secrets.error ?? set.error ?? remove.error)}
      onSelectStudio={setPicked}
      onSet={(deviceId, values) => {
        if (studioId !== null) set.mutate({ studioId, deviceId, values }, { onSuccess: () => toast.success(`Secret of ${deviceId} saved`) });
      }}
      onDelete={(deviceId) => {
        if (studioId !== null) remove.mutate({ studioId, deviceId }, { onSuccess: () => toast.success(`Secret of ${deviceId} deleted`) });
      }}
    />
  );
}
